export default __webpack_public_path__ + "static/media/cog.67fed36a.svg";